// DatabaseSettingsViewGroupsTab.jsx

import React from 'react';

// CSS
import './DatabaseSettingsViewGroupsTab.css';

// Components
import RegistryViewGroups from 'admin/nodetypes/viewgroups/RegistryViewGroups';
import Button from 'components/button/Button';
import ModalButtons from 'components/modal/buttons/ModalButtons';

/**
 * DatabaseSettingsViewGroupsTab
 *
 * Edits type-scoped view groups for a collection.
 *
 * @returns {ReactNode}
 */
const DatabaseSettingsViewGroupsTab = React.memo(({
  viewGroups = [],
  setViewGroups,
  saving = false,
  canSave = false,
  handleSave,
}) => {
  return (
    <div className="database-modal-view-groups">
      <div className="database-modal-view-groups-content">
        <RegistryViewGroups
          viewGroups={viewGroups}
          onChange={setViewGroups}
        />
      </div>
      <div className="database-modal-view-groups-actions">
        <ModalButtons
          style={{
            paddingLeft: 0,
            paddingRight: 0,
          }}
        >
          <div className="database-modal-view-groups-actions-right">
            <Button
              iconKey="check"
              label={saving ? 'Saving...' : 'Save Changes'}
              enabled={canSave}
              onClick={handleSave}
            />
          </div>
        </ModalButtons>
      </div>
    </div>
  );
});

DatabaseSettingsViewGroupsTab.displayName = 'DatabaseSettingsViewGroupsTab';

export default DatabaseSettingsViewGroupsTab;
